"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PixiFeatureBuyButtonBase = void 0;
var _core = require("@dragon/core");
var _gsap = _interopRequireDefault(require("gsap"));
var _pixi = require("pixi.js");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Button used for Pixi UI elements.
 * 
 * will handle generic button things.
 */
var PixiFeatureBuyButtonBase = exports.PixiFeatureBuyButtonBase = /*#__PURE__*/function (_Container) {
  function PixiFeatureBuyButtonBase(tex, pressCallback) {
    var _this;
    _classCallCheck(this, PixiFeatureBuyButtonBase);
    _this = _callSuper(this, PixiFeatureBuyButtonBase);
    _defineProperty(_this, "pressCallback", void 0);
    _defineProperty(_this, "disabled", void 0);
    _defineProperty(_this, "_baseScale", void 0);
    _defineProperty(_this, "sprite", void 0);
    _this.sprite = new _pixi.Sprite(tex);
    _this.pressCallback = pressCallback;
    _this.sprite.anchor.set(0.5);
    _this.sprite.interactive = true;
    _this.sprite.buttonMode = true;
    _this.sprite.on('mousedown', function () {
      return _this.onPress();
    }).on('touchstart', function () {
      return _this.onPress();
    }).on('pointerover', function () {
      return _this.onButtonOver();
    }).on('pointerout', function () {
      return _this.onButtonOut();
    });
    _this.addChild(_this.sprite);
    return _this;
  }
  _inherits(PixiFeatureBuyButtonBase, _Container);
  return _createClass(PixiFeatureBuyButtonBase, [{
    key: "onPress",
    value: function onPress() {
      if (this.disabled) return;
      this.pressCallback();
      _core.CORE.dispatch((0, _core.playSound)(_core.SoundPack.Shared, false, 'uiclick'));
    }

    /**
     * Override to remove default handling
     * @returns 
     */
  }, {
    key: "onButtonOut",
    value: function onButtonOut() {
      //  console.log('ON BUTTON OUT PARENT ')
      if (this.disabled) return;
      _gsap["default"].to(this, {
        alpha: 1,
        duration: 0.2
      });
      _gsap["default"].to(this.scale, {
        x: this._baseScale,
        y: this._baseScale,
        duration: 0.2
      });
    }
    /**
    * Override to remove default handling
    * @returns 
    */
  }, {
    key: "onButtonOver",
    value: function onButtonOver() {
      //  console.log('ON BUTTON OVER PARENT ')
      if (this.disabled) return;
      this._baseScale = this.scale.x;
      _gsap["default"].to(this, {
        alpha: 0.9,
        duration: 0.2
      });
      _gsap["default"].to(this.scale, {
        x: this._baseScale * 0.97,
        y: this._baseScale * 0.97,
        duration: 0.2
      });
    }
  }]);
}(_pixi.Container);
//# sourceMappingURL=PixiFeatureBuyButtonBase.js.map